"use client";

import { Button, Input } from "@relume_io/relume-ui";
import React from "react";
import ContactButton from "../../components/shared/ContactButton"

export function Cta20() {
  return (
    <section id="relume" className="relative px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="w-full max-w-lg">
          <h2 className="rb-5 mb-5 text-2xl md:mb-6 md:text-3xl lg:text-5xl lg:leading-15">
          Bleiben Sie mit Cybersecurity Insights auf dem Laufenden
          </h2>
          <p className="md:text-md">
          </p>
          <div className="mt-6 w-full max-w-sm md:mt-8">
            {/* <form className="rb-4 mb-4 grid max-w-sm grid-cols-1 gap-y-3 sm:grid-cols-[1fr_max-content] sm:gap-4">
              <Input id="email" type="email" placeholder="Your Email Address" />
              <Button title="Join Now">Jetzt anmelden</Button>
            </form> */}
           
           <ContactButton/>
            
          </div>
        </div>
      </div>
    </section>
  );
}
